import { render, staticRenderFns } from "./BusinessProspectsListView.vue?vue&type=template&id=bc5501f6&scoped=true&"
import script from "./BusinessProspectsListView.vue?vue&type=script&lang=ts&"
export * from "./BusinessProspectsListView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessProspectsListView.vue?vue&type=style&index=0&id=bc5501f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5501f6",
  null
  
)

export default component.exports